import { Image, Button, Card, Row } from "react-bootstrap";
import "./Portfolio.css";

import classifyImage from "../../img/classify-2.png";
// import vaultImage from "../../img/Screenshot 2022-05-02 140220.png";
// import fynpImage from "../../img/Screenshot 2022-05-02 140550.png";
import pokeGif from "../../img/ezgif-4-d4f4d4dce7.gif";
import weatherImage from "../../img/live_weather_dashboard.png";
import vaultCB from "../../img/homepageCAP.PNG";
import { FaGithub, FaPaperPlane } from "react-icons/fa";

const Portfolio = () => {
	return (
		<div className="containter d-block-flex carousel__holder">
			<Row className="flex m-2 proj-row">
				<h2 className="">Portfolio</h2>
			</Row>

			<Row className="flex m-2 proj-row">
				<Card className="projCard m-2 bg-dark text-white p-3">
					<Card.Img
						className="d-block project__image m-2"
						src={vaultCB}
						alt="Vault Character Builder Website"
					></Card.Img>
					<Card.Title>
						<h3>Vault Character Builder Website (in Alpha)</h3>
					</Card.Title>
					<Card.Text>
						A MERN stack character creation application for Vault TTRPG. Uses
						Apollo, Graph QL, React, Chakra UI, PDF generation, and JWT
						authentication.
					</Card.Text>
					<Card.Footer>
						<Button
							className="repoBtn"
							href="https://bit.ly/Vault-CB-repo"
							target="_blank"
							rel="noreferrer"
						>
							<FaGithub /> View the Repo
						</Button>
						<Button
							className="repoBtn mx-3"
							href="https://bit.ly/vaultAPP"
							target="_blank"
							rel="noreferrer"
						>
							<FaPaperPlane /> View the Deployed App
						</Button>
					</Card.Footer>
				</Card>
			</Row>

			<Row className="flex m-2 proj-row">
				<Card className="projCard m-2 bg-dark text-white p-3">
					<a
						className="m-2"
						href="https://bit.ly/Classify-Demo"
						target="_blank"
						rel="noreferrer"
					>
						<Card.Img
							className="d-block project__image "
							src={classifyImage}
							alt="Classify App"
						></Card.Img>
					</a>
					<Card.Title>
						<h3>Classify Web App</h3>
					</Card.Title>
					<Card.Text>
						A school or organization personnel and budget tracking MERN stack
						application. Uses Apollo, Graph QL, React, and JWT authentication.
					</Card.Text>
					<Card.Footer>
						<Button
							className="repoBtn"
							href="https://bit.ly/eeo-classify"
							target="_blank"
							rel="noreferrer"
						>
							<FaGithub /> View the Repo
						</Button>
						<Button
							className="repoBtn mx-3"
							href="https://bit.ly/Classify-Demo"
							target="_blank"
							rel="noreferrer"
						>
							<FaPaperPlane /> View the Deployed App
						</Button>
					</Card.Footer>
				</Card>
			</Row>

			<Row className="flex m-2 proj-row">
				<Card className="projCard m-2 bg-dark text-white p-3">
					<a
						className="m-2"
						href="https://bit.ly/3QOIqhh"
						target="_blank"
						rel="noreferrer"
					>
						<Card.Img
							className="d-block project__image "
							src={pokeGif}
							alt="Pokemon Info and Card Search"
						></Card.Img>
					</a>
					<Card.Title>
						<h3>Pokemon Trading Card Game Finder</h3>
					</Card.Title>
					<Card.Text>
						A trading card application for Pokemon. Uses two 3rd party Pokemon
						API's and custom mobile responsive CSS styling.
					</Card.Text>
					<Card.Footer>
						<Button
							className="repoBtn"
							href="https://bit.ly/3O9D7qP"
							target="_blank"
							rel="noreferrer"
						>
							<FaGithub /> View the Repo
						</Button>
						<Button
							className="repoBtn mx-3"
							href="https://bit.ly/3QOIqhh"
							target="_blank"
							rel="noreferrer"
						>
							<FaPaperPlane /> View the Deployed App
						</Button>
					</Card.Footer>
				</Card>
			</Row>

			<Row className="flex m-2 proj-row">
				<Card className="projCard m-2 bg-dark text-white p-3">
					<a
						className="m-2"
						href="https://eeoerkeedu.github.io/Live-Weather-Dashboard/"
						target="_blank"
						rel="noreferrer"
					>
						<Card.Img
							className="d-block project__image "
							src={weatherImage}
							alt="Live Weather Dashboard"
						></Card.Img>
					</a>
					<Card.Title>
						<h3>Live Weather Dashboard</h3>
					</Card.Title>
					<Card.Text>
						A great site to get weather results for searched cities. Uses the
						openweather API
					</Card.Text>
					<Card.Footer>
						<Button
							className="repoBtn"
							href="https://github.com/eeoerkeedu/Live-Weather-Dashboard"
							target="_blank"
							rel="noreferrer"
						>
							<FaGithub /> View the Repo
						</Button>
						<Button
							className="repoBtn mx-3"
							href="https://eeoerkeedu.github.io/Live-Weather-Dashboard/"
							target="_blank"
							rel="noreferrer"
						>
							<FaPaperPlane /> View the Deployed App
						</Button>
					</Card.Footer>
				</Card>
			</Row>
		</div>
	);
};

export default Portfolio;
